var fogExp4GravityPS = `
#ifndef FOG_GRAVITY
#define FOG_GRAVITY
uniform vec3 fog_color;
uniform float fog_density;
uniform float fog_start;
uniform float fog_end;
uniform float fog_height;
float dBlendModeFogFactor = 1.0;
vec3 addFogWithGravity(vec3 color, float vPositionWY) {
	float depth = gl_FragCoord.z / gl_FragCoord.w;
	vec3 fogColor = gammaCorrectInput(fog_color);
	
	float heightPercent = clamp(vPositionWY / fog_height, 0.0, 1.0);
	float heightBias = 1.0 - heightPercent;
	float adjustedDepth = max(depth - fog_start, 0.0);
	float density = fog_density * heightBias;
	float fogFactor = exp(-adjustedDepth * adjustedDepth * density * density * density * density);
	fogFactor = clamp(fogFactor, 0.0, 1.0);
	return mix(fogColor, color, fogFactor);
}
#endif
`;

export { fogExp4GravityPS as default };
